import React, { useEffect, useState } from "react";
import Chart from "chart.js";
import { Switch } from "antd";


const generateColors = (count, data) => {
  let baseColors = ["#ff8a70", "#80ff93", "#a28eff", "#ff8ede", "#ffc670", "#e3ff80", "#69c0ff", "#8efff2"];
  let baseColorsSex = [];
  let ctdM = 0;
  let ctdF = 0;
  let dataColumns = data["columns"];
  for (let i = 0; i < dataColumns.length; i++) {
    if (dataColumns[i].charAt(0) === "M" && dataColumns[i].charAt(1) !== "é") {
      switch (ctdM) {
        case 0:
          baseColorsSex.push("#4d9af8");
          ctdM++;
          break;
        case 1:
          baseColorsSex.push("#2778dc");
          ctdM++;
          break;
        case 2:
          baseColorsSex.push("#044ca3");
          ctdM++;
          break;
        case 3:
          baseColorsSex.push("#055724");
          ctdM++;
          break;
        default:
          baseColorsSex.push("#cecece")
          break;
      }
    } else if (dataColumns[i].charAt(0) === "F") {
      switch (ctdF) {
        case 0:
          baseColorsSex.push("#ff6666");
          ctdF++;
          break;
        case 1:
          baseColorsSex.push("#ed3838");
          ctdF++;
          break;
        case 2:
          baseColorsSex.push("#db3881");
          ctdF++;
          break;
        case 3:
          baseColorsSex.push("#edd713");
          ctdF++;
          break;
        default:
          baseColorsSex.push("#cecece")
          break;
      }
    } else if (dataColumns[i].charAt(0) === "T" && baseColorsSex.length > 0) {
      baseColorsSex.push("#cecece")
    } else if (dataColumns[i].charAt(0) === "M" && dataColumns[i].charAt(1) === "é") {
      baseColorsSex.push("#ffa500")
    }
    else if (dataColumns[i].charAt(0) === "R" && baseColorsSex.length > 0) {
      baseColorsSex.push("#ffa500")
    }
  }

  const colors = [];
  let useColors;
  if (baseColorsSex.length > 0) {
    useColors = [...baseColorsSex];
  } else {
    useColors = [...baseColors];
  }
  for (let i = 0; i < count; i++) {
    colors.push(useColors[i % useColors.length]);
  }
  return colors;
}

function charAverage(arr) {
  if (arr.length === 0) return (0).toFixed(1);
  let sum = arr.reduce(function (acc, curr) {
    return acc + curr.length;
  }, 0);
  return (sum / arr.length).toFixed(1);
}

function initializeChart(dataset) {
  if (!dataset) {
    return;
  }

  let groups = dataset["groups"];
  const labels = dataset["columns"];
  if (charAverage(groups) > 30) {
    groups = groups.map((group, index) => index + 1);
  }

  const numGroups = labels.length;
  const colors = generateColors(numGroups + 2, dataset);
  const datasets = labels.map((label, index) => ({
    label: label,
    backgroundColor: colors[index],
    data: dataset["values"][label],
    fill: false,
  }));

  const config = {
    type: "bar",
    data: {
      labels: groups,
      datasets: datasets,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'top',
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            let datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
            return datasetLabel + ': ' + tooltipItem.yLabel.toFixed(1) + '%';
          }
        }
      },
      scales: {
        xAxes: [
          {
            ticks: {
              fontColor: "black",
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Grupo",
              fontColor: "black",
            },
            gridLines: {
              display: false,
            },
            categoryPercentage: 0.5,
            barPercentage: 0.9,
          },
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "Valor  (%)",
              fontColor: "black",
            },
            ticks: {
              fontColor: "black",
              maxTicksLimit: 5,
              min: 0,
              beginAtZero: true,
            },
            gridLines: {
              display: true,
              color: "rgb(210, 210, 210)",
            },
          },
        ],
      },
    },
  };
  if (window.myLine) {
    window.myLine["chart"].destroy();
  }
  const ctx = document.getElementById("BarGraph").getContext("2d");
  window.myLine = new Chart(ctx, config);
}

const BarGraph = ({ data }) => {
  const [showIndividualTotal, setShowIndividualTotal] = useState(false);
  const [groupLegend, setGroupLegend] = useState(null);
  useEffect(() => {
    function fillDataset(data) {
      let groupedValues = data.values.map(lista => lista.slice(1));
      let groups = data.values.map(lista => lista[0])
      let haveUsableReference = data.reference.usableReferenceData;
      if (!showIndividualTotal) groups = [...groups, "Total"]

      const datasetFiltered = {
        columns: data.header.slice(1),
        groups: groups,
        values: {}
      }
      if(haveUsableReference && !showIndividualTotal) datasetFiltered.columns.pop()
      datasetFiltered["columns"].forEach((col, index) => {
        const colValues = groupedValues.map(list => list[index]);
        const total = colValues.reduce((acc, curr) => acc + parseFloat(curr), 0);
        datasetFiltered["values"][col] = [...colValues, total.toFixed(1)];
      });
      if (showIndividualTotal) {
        datasetFiltered["values"]["Total"] = new Array(datasetFiltered["values"][datasetFiltered["columns"][0]].length).fill(0);
        datasetFiltered["columns"].forEach(col => {
          if (haveUsableReference && datasetFiltered["columns"][datasetFiltered["columns"].length - 1] === col) return;
          for (let i = 0; i < datasetFiltered["values"][col].length; i++) {
            if (!isNaN(parseFloat(datasetFiltered["values"][col][i]))) {
              datasetFiltered["values"]["Total"][i] += parseFloat(datasetFiltered["values"][col][i]);
            }
          }
        });
        datasetFiltered["columns"] = [...datasetFiltered["columns"], "Total"];
        if (haveUsableReference) arraymove(datasetFiltered["columns"], datasetFiltered["columns"].length - 2, datasetFiltered["columns"].length - 1)
      }
      setGroupLegend(charAverage(datasetFiltered.groups) > 30 ? datasetFiltered.groups : null);
      return datasetFiltered;
    }
    initializeChart(fillDataset(data));
  }, [data, showIndividualTotal]);



  function arraymove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  function chunkArray(array, size) {
    const chunkedArr = [];
    let index = 0;
    while (index < array.length) {
      chunkedArr.push(array.slice(index, size + index));
      index += size;
    }
    return chunkedArr;
  }


  return (
    <>
      <div className="flex flex-col break-words rounded bg-blueGray-700 border-2 shadow-md">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative">
              <h6 className="uppercase text-blueGray-100 mb-1 text-xs font-semibold inline-block">
                Gráfico
              </h6>
            </div>
          </div>
          <Switch
            checked={showIndividualTotal}
            onChange={() => setShowIndividualTotal(!showIndividualTotal)}
            className="bg-gray-400 m-2" />
          <label className="text-sm">Total individual</label>
        </div>
        <div className="p-4 flex-auto">
          <div className="w-full">
            <canvas
              id="BarGraph"
              className="max-w-full "
              style={{ minHeight: '250px' }}
            ></canvas>
          </div>
        </div>
        <div className="flex flex-wrap justify-center">
          {groupLegend &&
            chunkArray(groupLegend, 3).map((chunk, chunkIndex) => (
              <div key={chunkIndex} className="flex flex-col m-2 max-w-64">
                {chunk.map((group, index) => (
                  <span key={chunkIndex * 3 + index} className="text-xs text-blueGray-400 flex-row flex my-auto mr-3">
                    <p className="font-bold">{chunkIndex * 3 + index + 1}</p> - {group}
                  </span>
                ))}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default BarGraph;
